import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

const desktopQuery = window.matchMedia('(min-width: 768px)');
const instances = new Map();

function getContainerKey(container, index) {
  if (container.id) {
    return container.id;
  }

  if (!container.dataset.sliderKey) {
    container.dataset.sliderKey = `news-slider-${index}`;
  }

  return container.dataset.sliderKey;
}

function shouldAutoplay(container) {
  return container.dataset.autoplayMobile === '1' || container.dataset.autoplayMobile === 'true';
}

function getAutoplayDelay(container) {
  const delay = Number.parseInt(container.dataset.autoplayDelay || '5000', 10);

  return Number.isFinite(delay) && delay > 0 ? delay : 5000;
}

function destroyInstance(key) {
  const swiper = instances.get(key);

  if (!swiper) {
    return;
  }

  swiper.destroy(true, true);
  instances.delete(key);
}

function initInstances() {
  const containers = document.querySelectorAll('.news-slider__swiper');
  const isMobile = !desktopQuery.matches;

  containers.forEach((container, index) => {
    const key = getContainerKey(container, index);
    const slideCount = container.querySelectorAll('.swiper-slide').length;

    if (slideCount <= 1) {
      destroyInstance(key);
      return;
    }

    if (!isMobile) {
      destroyInstance(key);
      return;
    }

    const autoplayEnabled = shouldAutoplay(container);

    if (instances.has(key)) {
      const swiper = instances.get(key);

      if (swiper && swiper.autoplay) {
        if (autoplayEnabled) {
          swiper.params.autoplay = {
            delay: getAutoplayDelay(container),
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          };
          swiper.autoplay.start();
        }

        if (!autoplayEnabled) {
          swiper.autoplay.stop();
          swiper.params.autoplay = false;
        }
      }

      swiper.update();
      return;
    }

    const swiper = new Swiper(container, {
      modules: [Autoplay, Pagination],
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 16,
      watchOverflow: true,
      pagination: {
        el: container.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true,
      },
      autoplay: autoplayEnabled
        ? {
            delay: getAutoplayDelay(container),
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
      on: {
        init() {
          if (autoplayEnabled && this.autoplay) {
            this.autoplay.start();
          }
        },
      },
    });

    instances.set(key, swiper);
  });
}

let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(initInstances, 150);
});

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', initInstances);
} else {
  initInstances();
}

desktopQuery.addEventListener('change', () => {
  initInstances();
});